import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AttrIndexService } from 'app/services/attr-index.service';
import { LineDirection, MapSharedService } from 'app/services/map-shared.service';
import { CenterlineSide, QaResolverFeed, RCRecordItem, ResoCenterCol, ResoCenterRule, ResolutionCenterService } from 'app/services/resolution-center.service';
import { RCCellChangeData } from '../rc-cell/rc-cell.component';

import WKT from 'ol/format/WKT';
import { ActivityService } from 'app/services/activity.service';
import { Subscription } from 'rxjs';
import { JstsService } from 'app/services/jsts.service';
import { LineString } from 'ol/geom';
import { FlipRoadService } from 'app/services/flip-road.service';
import { ParityValue, ResolutionQcService } from 'app/services/resolution-qc.service';

export type RelativePosition = 'upper' | 'lower' | 'left' | 'right';
export interface RCRecordItemExt extends RCRecordItem {
	direction?: LineDirection;
	horizontalVertical?: 'hori' | 'vert'; // Line direction E/W is considered horizontal, line direction N/S is vertical
	relativePosition?: RelativePosition; // relative postions for the two RAO lines drawn in the reso tab
		// bbox?: number[];

	isFromLeftError?: boolean;
	isToLeftError?: boolean;
	isFromRightError?: boolean;
	isToRightError?: boolean;
}

@Component({
  selector: 'app-resolution-rao',
  templateUrl: './resolution-rao.component.html',
  styleUrls: ['./resolution-rao.component.css', '../resolution-inspector/resolution-inspector.component.css']
})
export class ResolutionRAOComponent implements OnInit, OnChanges, OnDestroy {

	@Input() resolverFeed: QaResolverFeed;

	@Output() edit: EventEmitter<any> = new EventEmitter();

	rules: ResoCenterRule[] = [];

	centerlineList: RCRecordItemExt[];

	fromAddrLeftCol: ResoCenterCol;
	toAddrLeftCol: ResoCenterCol;
	fromAddrRightCol: ResoCenterCol;
	toAddrRightCol: ResoCenterCol;

		// // If address ranges on the left side of routes has error
		// isLeftError: boolean;
		// // If address ranges on the right side of routes has error
		// isRightError: boolean;

	relativePosition: 'leftRight' | 'upperLower';
	isRelativePosConsistentWithDirection: boolean; // Is the relative position of 2 lines (hori/vert) same as the lines' own direction (N/S as vert, E/W as hori)
	isRoadsConnected: boolean;
	firstEndConnected: boolean = true;
	secondEndConnected: boolean = true;
	connectedEnd: 'first' | 'second' | 'both';

	currentId;

	private parityLeftColName = 'grd_parity_l';
	private parityRightColName = 'grd_parity_r';

	private currentCardSub: Subscription;
	private flipRoadSub: Subscription;

	constructor(
		private activityService: ActivityService,
		private attrIndexService: AttrIndexService,
		private flipRoadService: FlipRoadService,
		private jstsService: JstsService,
		private mapSharedService: MapSharedService,
		private resoCenterService: ResolutionCenterService,
		private resoQcService: ResolutionQcService
	) { }

	onEdit(idx, e: RCCellChangeData) {
		this.resoCenterService.onEditRecord(this.centerlineList[idx], e.col);
		//
		let side: CenterlineSide;
		if (e.col.prop === this.fromAddrLeftCol.prop || e.col.prop === this.toAddrLeftCol.prop) {
			side = 'left';
		} else {
			side = 'right';
		}
		this.updateRAO(side);
		this.updateParity(this.centerlineList[idx], side);
		// let changedCols = [e.col];
		this.edit.emit();
	}
		// attachToLarger(side?: CenterlineSide) {
		// 	if (!side) {
		// 		side = 'left';
		// 	}
		// 	let parityColName: string, fromCol: ResoCenterCol, toCol: ResoCenterCol;
		// 	if (side === 'left') {
		// 		parityColName = this.parityLeftColName;
		// 		fromCol = this.fromAddrLeftCol;
		// 		toCol = this.toAddrLeftCol;
		// 	} else {
		// 		parityColName = this.parityRightColName;
		// 		fromCol = this.fromAddrRightCol;
		// 		toCol = this.toAddrRightCol;
		// 	}
		// 	const parity = this.centerlineList[0].props[parityColName];
		// 	const attachTo = this.centerlineList[1].props[fromCol.prop];
		// 	let value = this.centerlineList[0].props[toCol.prop];
		// 	if (parity === 'E') {
		// 		value = attachTo % 2 === 0 ? attachTo - 2 : attachTo - 1;
		// 	} else if (parity === 'O') {
		// 		value = attachTo % 2 === 0 ? attachTo - 1 : attachTo - 2;
		// 	} else {
		// 		value = attachTo - 1;
		// 	}
		// 	this.centerlineList[0].props[toCol.prop] = value;
		// 	this.onEdit(0, {
		// 		val: value,
		// 		col: toCol
		// 	});
		// }
		// attachToLower(side?: CenterlineSide) {
		// 	if (!side) {
		// 		side = 'left';
		// 	}
		// 	let parityColName: string, fromCol: ResoCenterCol, toCol: ResoCenterCol;
		// 	if (side === 'left') {
		// 		parityColName = this.parityLeftColName;
		// 		fromCol = this.fromAddrLeftCol;
		// 		toCol = this.toAddrLeftCol;
		// 	} else {
		// 		parityColName = this.parityRightColName;
		// 		fromCol = this.fromAddrRightCol;
		// 		toCol = this.toAddrRightCol;
		// 	}
		// 	const parity = this.centerlineList[1].props[parityColName];
		// 	const attachTo = this.centerlineList[0].props[toCol.prop];
		// 	let value = this.centerlineList[1].props[fromCol.prop];
		// 	if (parity === 'E') {
		// 		value = attachTo % 2 === 0 ? attachTo + 2 : attachTo + 1;
		// 	} else if (parity === 'O') {
		// 		value = attachTo % 2 === 0 ? attachTo + 1 : attachTo + 2;
		// 	} else {
		// 		value = attachTo + 1;
		// 	}
		// 	this.centerlineList[1].props[fromCol.prop] = value;
		// 	this.onEdit(1, {
		// 		val: value,
		// 		col: fromCol
		// 	});
		// }

	attach(e: {side: CenterlineSide; id;}) {
		const lineIdx = this.centerlineList.findIndex(l => l.id === e.id);
		const line = this.centerlineList[lineIdx];
		const attachToLine = lineIdx === 0 ? this.centerlineList[1] : this.centerlineList[0];
		let parityColName: string, fromCol: ResoCenterCol, toCol: ResoCenterCol;
		let errorCol: ResoCenterCol;
		let attachToCol: ResoCenterCol;
		let isIncrease: boolean;
		if (e.side === 'left') {
			fromCol = this.fromAddrLeftCol;
			toCol = this.toAddrLeftCol;
			parityColName = this.parityLeftColName;
			//
			errorCol = line.isFromLeftError ? this.fromAddrLeftCol : this.toAddrLeftCol;
			attachToCol = line.isFromLeftError ? this.toAddrLeftCol : this.fromAddrLeftCol;
			isIncrease = line.isFromLeftError ? true : false;
		} else if (e.side === 'right') {
			fromCol = this.fromAddrRightCol;
			toCol = this.toAddrRightCol;
			parityColName = this.parityRightColName;
			//
			errorCol = line.isFromRightError ? this.fromAddrRightCol : this.toAddrRightCol;
			attachToCol = line.isFromRightError ? this.toAddrRightCol : this.fromAddrRightCol;
			isIncrease = line.isFromRightError ? true : false;
		}
		const parity: ParityValue = line.props[parityColName];
		const attachToValue = attachToLine.props[attachToCol.prop];
		let value = line.props[errorCol.prop];
		const delta1 = isIncrease ? 1 : -1;
		const delta2 = isIncrease ? 2 : -2;
		if (parity === 'E') {
			value = attachToValue % 2 === 0 ? attachToValue + delta2 : attachToValue + delta1;
		} else if (parity === 'O') {
			value = attachToValue % 2 === 0 ? attachToValue + delta1 : attachToValue + delta2;
		} else {
			value = attachToValue + delta1;
		}
		line.props[errorCol.prop] = value;
		this.onEdit(lineIdx, {
			val: value,
			col: errorCol
		});
	}
	flipFromTo(e: {side: CenterlineSide; id;}) {
		const lineIdx = this.centerlineList.findIndex(l => l.id === e.id);
		const line = this.centerlineList[lineIdx];
		let fromCol: ResoCenterCol, toCol: ResoCenterCol;
		if (e.side === 'left') {
			fromCol = this.fromAddrLeftCol;
			toCol = this.toAddrLeftCol;
		} else if (e.side === 'right') {
			fromCol = this.fromAddrRightCol;
			toCol = this.toAddrRightCol;
		}
		const fromVal = line.props[fromCol.prop];
		const toVal = line.props[toCol.prop];
		line.props[fromCol.prop] = toVal;
		line.props[toCol.prop] = fromVal;
		this.onEdit(lineIdx, {
			val: fromVal,
			col: toCol
		});
		this.onEdit(lineIdx, {
			val: toVal,
			col: fromCol
		});
	}
	jointChange(e: {side: CenterlineSide, idx;}) {
		let direction: 'increase' | 'decrease';
		const side = e.side;
		const lineIdx = e.idx;
		const line = this.centerlineList[lineIdx];

		let fromCol: ResoCenterCol, toCol: ResoCenterCol, parityColName: string;
		if (side === 'left') {
			fromCol = this.fromAddrLeftCol;
			toCol = this.toAddrLeftCol;
			parityColName = this.parityLeftColName;
		} else {
			fromCol = this.fromAddrRightCol;
			toCol = this.toAddrRightCol;
			parityColName = this.parityRightColName;
		}
		// Changed fields for first line and second line
		let firstCol: ResoCenterCol, secondCol: ResoCenterCol;
		if (lineIdx === 0) {
			if (line.direction === 'E' || line.direction === 'S') {
				firstCol = toCol;
				secondCol = fromCol;
				direction = 'increase';
			} else {
				firstCol = fromCol;
				secondCol = toCol;
				direction = 'decrease';
			}
		} else if (lineIdx === 1) {
			if (line.direction === 'E' || line.direction === 'S') {
				firstCol = toCol;
				secondCol = fromCol;
				direction = 'decrease';
			} else {
				firstCol = fromCol;
				secondCol = toCol;
				direction = 'increase';
			}
		} else {
			return;
		}
			// const getDeltaByParity = (parity: ParityValue, value) => {
			// 	if (parity !== 'E' && parity !== 'O') {
			// 		return 1;
			// 	}
			// 	const valueParity = value % 2 === 0 ? 'E' : 'O'
			// 	let delta = valueParity === parity ? 2 : 1; 
			// 	if (direction === 'decrease') {
			// 		delta = delta * -1;
			// 	}
			// 	return delta;
			// }


		let firstValue: number = this.centerlineList[0].props[firstCol.prop];
		const firstParity = this.centerlineList[0].props[parityColName];
		const firstDelta = this.resoCenterService.getDeltaValueByParity(firstValue, firstParity, direction);
		//
		let secondValue: number = this.centerlineList[1].props[secondCol.prop];
		const secondParity = this.centerlineList[1].props[parityColName];
		const secondDelta = this.resoCenterService.getDeltaValueByParity(secondValue, secondParity, direction);
		// const secondValueParity: 'E' | 'O' = secondValue % 2 === 0 ? 'E' : 'O';
		// const secondDelta = secondValueParity === secondParity ? 2 : 1; 
		this.centerlineList[0].props[firstCol.prop] = firstValue + firstDelta;
		this.centerlineList[1].props[secondCol.prop] = secondValue + secondDelta;
		this.onEdit(0, {
			val: firstValue,
			col: firstCol
		});
		this.onEdit(1, {
			val: secondValue,
			col: secondCol
		});
	}

	// If side isn't passed, check both sides
	updateRAO(side?: CenterlineSide) {
			// const rao = this.centerlineList.find((l, idx) => {
			// 	if (idx >= this.centerlineList.length - 1) {
			// 		return;
			// 	}
			// 	if (l.props[parityColName] === 'Z' || this.centerlineList[idx + 1].props[parityColName] === 'Z') {
			// 		return;
			// 	}
			// 	if (l.props[toCol.prop] >= this.centerlineList[idx + 1].props[fromCol.prop]) {
			// 		return true;
			// 	}
			// })
		const setClean = (line: RCRecordItemExt) => {
			if (!side || side === 'left') {
				line.isFromLeftError = null;
				line.isToLeftError = null;
			}
			if (!side || side === 'right') {
				line.isFromRightError = null;
				line.isToRightError = null;
			}
		}
		const line1 = this.centerlineList[0];
		const line2 = this.centerlineList[1];
		setClean(line1);
		setClean(line2);
		const parityColName = side === 'left' ? this.parityLeftColName : this.parityRightColName;
		let fromCol: ResoCenterCol;
		let toCol: ResoCenterCol;
		const check = (s: 'left' | 'right') => {
			if (line1.props[parityColName] === 'Z' || line2.props[parityColName] === 'Z') {
				return;
			}
			let measureSmallerLine: RCRecordItemExt, measureLargerLine: RCRecordItemExt;
			if (line1.props[fromCol.prop] < line2.props[fromCol.prop] && line1.props[toCol.prop] > line2.props[fromCol.prop]) {
				measureSmallerLine = line1;
				measureLargerLine = line2;
			} else if (line1.props[fromCol.prop] > line2.props[fromCol.prop] && line1.props[fromCol.prop] < line2.props[toCol.prop]) {
				measureSmallerLine = line2;
				measureLargerLine = line1;
			} else {
				if (line1.props[fromCol.prop] === line2.props[fromCol.prop]) {
					if (line1.direction === line2.direction) {
						if (line1.direction === 'E' || line1.direction === 'S') {
							measureSmallerLine = line1;
							measureLargerLine = line2;
						} else {
							measureSmallerLine = line2;
							measureLargerLine = line1;
						}
					} else {
						measureSmallerLine = line1.props[toCol.prop] < line2.props[toCol.prop] ? line1 : line2;
						measureLargerLine = line1.props[toCol.prop] < line2.props[toCol.prop] ? line2 : line1;
					}
				}
			}
			if (!measureSmallerLine || !measureLargerLine) {
				return;
			}
			if (s === 'left') {
				measureSmallerLine.isToLeftError = true;
				measureLargerLine.isFromLeftError = true;
			} else {
				measureSmallerLine.isToRightError = true;
				measureLargerLine.isFromRightError = true;
			}
		}
		// Check left
		if (!side || side === 'left') {
			fromCol = this.fromAddrLeftCol;
			toCol = this.toAddrLeftCol;
			check('left');
		}
		// Check right
		if (!side || side === 'right') {
			fromCol = this.fromAddrRightCol;
			toCol = this.toAddrRightCol;
			check('right');
		}
	}
	private updateParity(centerline: RCRecordItemExt, side?: CenterlineSide) {
		const changedCols: string[] = [];
		const update = (fromProp: string, toProp, parityProp: string) => {
			const from = centerline.props[fromProp];
			const to = centerline.props[toProp];
			const parity = this.resoQcService.getParity(from, to);
			if (centerline.props[parityProp] !== parity) {
				centerline.props[parityProp] = parity;
				changedCols.push(parityProp);
				this.resoCenterService.onEditRecord(centerline, {
					prop: parityProp
				});
			}
		}
		let fromCol: ResoCenterCol, toCol: ResoCenterCol, parityColName: string;
		if (!side || side === 'left') {
			fromCol = this.fromAddrLeftCol;
			toCol = this.toAddrLeftCol;
			parityColName = this.parityLeftColName;
			update(fromCol.prop, toCol.prop, parityColName);
		}
		if (!side || side === 'right') {
			fromCol = this.fromAddrRightCol;
			toCol = this.toAddrRightCol;
			parityColName = this.parityRightColName;
			update(fromCol.prop, toCol.prop, parityColName);
		}
		return changedCols;
	}

	private async onFeedChange() {
		if (!this.resolverFeed) {
			return;
		}
		const layerCateCode = Object.keys(this.resolverFeed.feed)[0];
		const cols = await this.resoCenterService.transformCols(this.resolverFeed.feed[layerCateCode].cols, layerCateCode);
		const centerlineList = await this.resoCenterService.transformItemList(this.resolverFeed, layerCateCode);
		// This has to go after transformItemList because details are updated in it
		this.resoCenterService.setRelatedIds(this.resolverFeed);
		this.centerlineList = centerlineList;
		this.centerlineList.forEach(l => {
			this.calculateDirection(l);
		});
		this.calculateRelativePosition();
		if (this.centerlineList[1].relativePosition === 'left' || this.centerlineList[1].relativePosition === 'upper') {
			// Switch position in array
			this.centerlineList = [this.centerlineList[1], this.centerlineList[0]];
		}
		const wktFormat = new WKT();
		const wkt1 = this.centerlineList[0].props[this.attrIndexService.geomColManual];
		const wkt2 = this.centerlineList[1].props[this.attrIndexService.geomColManual];
		const geom1 = wkt1 ? (<LineString>wktFormat.readGeometry(wkt1)) : null;
		const geom2 = wkt2 ? (<LineString>wktFormat.readGeometry(wkt2)) : null;
		this.checkRoadsConnected(geom1, geom2);
		this.checkRoadsRings(geom1, geom2, this.centerlineList[0], this.centerlineList[1]);
		//
		this.fromAddrLeftCol = cols.find(c => c.prop === this.attrIndexService.fromAddrLeftColName);
		this.toAddrLeftCol = cols.find(c => c.prop === this.attrIndexService.toAddrLeftColName);
		this.fromAddrRightCol = cols.find(c => c.prop === this.attrIndexService.fromAddrRightColName);
		this.toAddrRightCol = cols.find(c => c.prop === this.attrIndexService.toAddrRightColName);
		// Draw the other line one map
		if (this.centerlineList.length > 1) {
			const additionalLine = this.centerlineList.find(l => l.id !== this.currentId);
			this.resoCenterService.drawAdditionalRcSubject.next({
				recordsInfo: [{
					wkt: additionalLine.props[this.attrIndexService.geomColManual],
					id: additionalLine.id
				}]
			})
		}
			// // sort by fromAddressLeft value ascending
			// 	this.centerlineList.sort((a, b) => {
			// 		const fromAddrL1 = a.props[this.fromAddrLeftCol.prop];
			// 		const fromAddrL2 = b.props[this.fromAddrLeftCol.prop];
			// 		if (fromAddrL1 !== fromAddrL2) {
			// 			if (fromAddrL1 && fromAddrL2) {
			// 				if (fromAddrL1 > fromAddrL2) {
			// 					return 1;
			// 				} else {
			// 					return -1;
			// 				}
			// 			} else if (!fromAddrL2) {
			// 				return 1;
			// 			} else if (!fromAddrL1) {
			// 				return -1;
			// 			}
			// 		} else {
			// 			const fromAddrR1 = a.props[this.fromAddrRightCol.prop];
			// 			const fromAddrR2 = b.props[this.fromAddrRightCol.prop];
			// 			if (fromAddrR1 !== fromAddrR2) {
			// 				if (fromAddrR1 && fromAddrR2) {
			// 					if (fromAddrR1 > fromAddrR2) {
			// 						return 1;
			// 					} else {
			// 						return -1;
			// 					}
			// 				} else if (!fromAddrR2) {
			// 					return 1;
			// 				} else if (!fromAddrR1) {
			// 					return -1;
			// 				}
			// 			}
			// 		}
			// 	})
		this.rules = this.resoCenterService.transformRules(this.resolverFeed.rules);

		this.updateRAO();

	}

	private calculateDirection(l: RCRecordItemExt) {
		const wkt = l.props[this.attrIndexService.geomColManual];
		if (!wkt) {
			return;
		}
		const wktFormat = new WKT();
		const olGeom = wktFormat.readGeometry(wkt);
		const direction = this.mapSharedService.getLineFeatureDirection(olGeom);
		l.direction = direction;
		if (direction === 'E' || direction === 'W') {
			l.horizontalVertical = 'hori';
		} else if (direction === 'N' || direction === 'S') {
			l.horizontalVertical = 'vert';
		}
	}
	private calculateRelativePosition() {
		try {
			const line1 = this.centerlineList[0];
			const line2 = this.centerlineList[1];
			const wktFormat = new WKT();
			const wkt1 = this.centerlineList[0].props[this.attrIndexService.geomColManual];
			const wkt2 = this.centerlineList[1].props[this.attrIndexService.geomColManual];
			const line1Geom = wkt1 ? wktFormat.readGeometry(wkt1) : null;
			const line2Geom = wkt2 ? wktFormat.readGeometry(wkt2) : null;
			let relativePosition: 'leftRight' | 'upperLower' = 'leftRight';
			if (line1 && line2 && line1Geom && line2Geom) {
				const bbox1 = line1Geom.getExtent(), bbox2 = line2Geom.getExtent();
				const xmin1 = bbox1[0], xmax1 = bbox1[2], ymin1 = bbox1[1], ymax1 = bbox1[3];
				const xmin2 = bbox2[0], xmax2 = bbox2[2], ymin2 = bbox2[1], ymax2 = bbox2[3];
				if (line1.horizontalVertical === line2.horizontalVertical) {
					// Both lines are horizontal
					if (line1.horizontalVertical === 'hori') {
						const shorterX = Math.min(xmax1 - xmin1, xmax2 - xmin2);
						const overlapRange = this.mapSharedService.getRangeOverlap([xmin1, xmax1], [xmin2, xmax2]);
						if (overlapRange) {
							const overlap = overlapRange[1] - overlapRange[0];
							if (overlap > shorterX / 2) {
								relativePosition = 'upperLower';
							}
						}
						if (relativePosition === 'leftRight') {
							if (xmin1 <= xmin2) {
								line1.relativePosition = 'left';
								line2.relativePosition = 'right';
							} else {
								line1.relativePosition = 'right';
								line2.relativePosition = 'left';
							}
						} else if (relativePosition === 'upperLower') {
							line1.relativePosition = 'upper';
							line2.relativePosition = 'lower';
							const overlapStartX = overlapRange[0];
							const parser = this.jstsService.getJstsParser();
							const jstsYLine = parser.read(new LineString([[overlapStartX, Math.min(ymin1, ymin2)], [overlapStartX, Math.max(ymax1, ymax2)]]));
							const jstsLine1 = parser.read(line1Geom);
							const jstsLine2 = parser.read(line2Geom);
							// OverlayOp.overlayOp
							const intersection1 = this.jstsService.getJstsOverlayOp().intersection(jstsLine1, jstsYLine); // jstsLine1.intersection(jstsYLine);
							const intersection2 = this.jstsService.getJstsOverlayOp().intersection(jstsLine2, jstsYLine); // jstsLine2.intersection(jstsYLine);
							if (intersection1 && intersection2) {
								const coord1 = intersection1.getCoordinates()[0];
								const coord2 = intersection2.getCoordinates()[0];
								if (coord1 && coord2 && coord1.y < coord2.y) {
									line1.relativePosition = 'lower';
									line2.relativePosition = 'upper';
								}
							} 
						}
					}
					// Both lines are vertical
					else if (line1.horizontalVertical === 'vert') {
						const shorterY = Math.min(ymax1 - ymin1, ymax2 - ymin2);
						const overlapRange = this.mapSharedService.getRangeOverlap([ymin1, ymax1], [ymin2, ymax2]);
						relativePosition = 'upperLower';
						if (overlapRange) {
							const overlap = overlapRange[1] - overlapRange[0];
							if (overlap > shorterY / 2) {
								relativePosition = 'leftRight';
							}
						}
						if (relativePosition === 'upperLower') {
							if (ymin1 <= ymin2) {
								line1.relativePosition = 'lower';
								line2.relativePosition = 'upper';
							} else {
								line1.relativePosition = 'upper';
								line2.relativePosition = 'lower';
							}
						} else if (relativePosition === 'leftRight') {
							line1.relativePosition = 'left';
							line2.relativePosition = 'right';
							const overlapStartY = overlapRange[1];
							const parser = this.jstsService.getJstsParser();
							const jstsXLine = parser.read(new LineString([[Math.min(xmin1, xmin2), overlapStartY], [Math.max(xmax1, xmax2), overlapStartY]]));
							const jstsLine1 = parser.read(line1Geom);
							const jstsLine2 = parser.read(line2Geom);
							const intersection1 = this.jstsService.getJstsOverlayOp().intersection(jstsLine1, jstsXLine); // jstsLine1.intersection(jstsXLine);
							const intersection2 = this.jstsService.getJstsOverlayOp().intersection(jstsLine2, jstsXLine); // jstsLine2.intersection(jstsXLine);
							if (intersection1 && intersection2) {
								const coord1 = intersection1.getCoordinates()[0];
								const coord2 = intersection2.getCoordinates()[0];
								if (coord1 && coord2 && coord1.x > coord2.x) {
									line1.relativePosition = 'right';
									line2.relativePosition = 'left';
								}
							} 
						}
					}
				} else {
					line1.relativePosition = 'left';
					line2.relativePosition = 'right';
				}
			}
			this.relativePosition = relativePosition;
			if (line1.horizontalVertical === line2.horizontalVertical) {
				if (line1.horizontalVertical === 'hori' && this.relativePosition === 'leftRight') {
					this.isRelativePosConsistentWithDirection = true;
				} else if (line1.horizontalVertical === 'vert' && this.relativePosition === 'upperLower') {
					this.isRelativePosConsistentWithDirection = true;
				} else {
					this.isRelativePosConsistentWithDirection = false;
				}
			} else {
				this.isRelativePosConsistentWithDirection = false;
			}
		} catch (err) {
			console.log(err);
		}
	}
	// Is the terminal point of one road connected with the terminal point of the other road
	private checkRoadsConnected(roadGeomA: LineString, roadGeomB: LineString) {
		let connected = false;
		if (roadGeomA && roadGeomB) {
			const coordsA = roadGeomA.getCoordinates()
			const startPointA = coordsA[0];
			const endPointA = coordsA[coordsA.length - 1];
			const coordsB = roadGeomB.getCoordinates()
			const startPointB = coordsB[0];
			const endPointB = coordsB[coordsB.length - 1];
			if (this.mapSharedService.isCoordsEqual(startPointA, startPointB)) {
				connected = true;
			} else if (this.mapSharedService.isCoordsEqual(startPointA, endPointB)) {
				connected = true;
			} else if (this.mapSharedService.isCoordsEqual(endPointA, startPointB)) {
				connected = true;
			} else if (this.mapSharedService.isCoordsEqual(endPointA, endPointB)) {
				connected = true;
			}
		}
		this.isRoadsConnected = connected;
	}
	private checkRoadsRings(roadGeom1: LineString, roadGeom2: LineString, line1: RCRecordItemExt, line2: RCRecordItemExt) {
		let firstEndConnected = false;
		let secondEndConnected = false;
		if (roadGeom1 && roadGeom2) {
			const coords1 = roadGeom1.getCoordinates()
			const startPoint1 = coords1[0];
			const endPoint1 = coords1[coords1.length - 1];
			const coords2 = roadGeom2.getCoordinates()
			const startPoint2 = coords2[0];
			const endPoint2 = coords2[coords2.length - 1];
			let relativePosition: 'hori' | 'verti';
			if (this.relativePosition === 'leftRight') {
				relativePosition = 'hori';
			} else if (this.relativePosition === 'upperLower') {
				relativePosition = 'verti';
			}
			if (line1.horizontalVertical === line2.horizontalVertical && line1.horizontalVertical !== relativePosition) {
				let firstPoint1, secondPoint1, firstPoint2, secondPoint2;
				if (line1.horizontalVertical === 'hori') {
					if (startPoint1[0] <= endPoint1[0]) {
						firstPoint1 = startPoint1;
						secondPoint1 = endPoint1;
					} else {
						firstPoint1 = endPoint1;
						secondPoint1 = startPoint1;
					}
					if (startPoint2[0] <= endPoint2[0]) {
						firstPoint2 = startPoint2;
						secondPoint2 = endPoint2;
					} else {
						firstPoint2 = endPoint2;
						secondPoint2 = startPoint2;
					}
				} else if (line1.horizontalVertical === 'vert') {
					if (startPoint1[1] >= endPoint1[1]) {
						firstPoint1 = startPoint1;
						secondPoint1 = endPoint1;
					} else {
						firstPoint1 = endPoint1;
						secondPoint1 = startPoint1;
					}
					if (startPoint2[1] >= endPoint2[1]) {
						firstPoint2 = startPoint2;
						secondPoint2 = endPoint2;
					} else {
						firstPoint2 = endPoint2;
						secondPoint2 = startPoint2;
					}
				}
				if (this.mapSharedService.isCoordsEqual(firstPoint1, firstPoint2)) {
					firstEndConnected = true;
				}
				if (this.mapSharedService.isCoordsEqual(secondPoint1, secondPoint2)) {
					secondEndConnected = true;
				}
			}
		}
		this.firstEndConnected = firstEndConnected;
		this.secondEndConnected = secondEndConnected;
		if (this.firstEndConnected && this.secondEndConnected) {
			this.connectedEnd = 'both';
		} else if (this.firstEndConnected) {
			this.connectedEnd = 'first';
		} else if (this.secondEndConnected) {
			this.connectedEnd = 'second';
		} else {
			this.connectedEnd = null;
		}
	}
	ngOnInit() {
		this.currentCardSub = this.activityService.currentCardBS.subscribe(data => {
			if (data) {
				this.currentId = data.id;
			}
		});
		this.flipRoadSub = this.flipRoadService.afterFlipRoadSubject.subscribe(data => {
			if (!data || !data.id) {
				return;
			}
			if (!data.flipedWkt && (!data.transposeCols || !data.transposeCols.length)) {
				return;
			}
			const id = data.id;
			const line = this.centerlineList.find(i => i.id === id);
			if (data.transposeCols && data.transposeCols && data.transposeCols.length) {
				data.transposeCols.forEach(c => {
					this.resoCenterService.onEditRecord(line, {prop: c.leftProp});
					this.resoCenterService.onEditRecord(line, {prop: c.rightProp});
				})
			}
			if (data.flipedWkt) {
				this.resoCenterService.onEditRecord(line, null, true);
			}
			this.calculateDirection(line);
			this.updateRAO();
			this.updateParity(line);
			this.edit.emit();
		});
	}
	async ngOnChanges(changes: SimpleChanges) {
		if (changes.resolverFeed) {
			console.log('On feed change, RAO')
			await this.onFeedChange();
		}
	}
	ngOnDestroy(): void {
		this.currentCardSub.unsubscribe();
		this.flipRoadSub.unsubscribe();
	}
}
